import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import style from './index.module.css';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import CountUp from 'react-countup';
import { useColorMode } from '../../theme/ThemeContext';
import { useTheme } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../../logo.svg';

const Navbar = ({ visitedCount }) => {
	const theme = useTheme();
	const { toggleColorMode, mode } = useColorMode();
	
	const navItems = [
		'Home',
		'About Us',
		'Why Us',
		'Our Services',
		'Gallery',
		'Clients',
		'Stories',
		'Contact',
	];
	const navItemsLinkId = [
		'/',
		'/about_us',
		'/why_us',
		'/our_services',
		'/gallery',
		'/clients',
		'/stories',
		'/contact',
	];
	const [sidebarOpened, setSidebarOpened] = useState(false);

	return (
		<>
			<motion.div 
				initial={{ y: -100 }}
				animate={{ y: 0 }}
				transition={{ duration: 0.5, type: 'spring', stiffness: 120 }}
				className={style.header}
				style={{
					backgroundColor: mode === 'light' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(18, 18, 18, 0.8)',
					backdropFilter: 'blur(10px)',
					borderBottom: `1px solid ${mode === 'light' ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}`,
					color: theme.palette.text.primary,
				}}
			>
				<Link className={style.logoContainer} to={'/'}>
					<img src={Logo} alt="Logo" className={style.logo} />
					<span className={style.h1} style={{ color: theme.palette.primary.main }}>
						Shri Hari
					</span>
				</Link>
				
				<nav>
					<ul>
						{navItems.map((item, index) => {
							return (
								<motion.li 
									key={index} 
									whileHover={{ scale: 1.1 }}
									whileTap={{ scale: 0.95 }}
									className='item'
								>
									<Link
										className={style.link}
										to={navItemsLinkId[index]}
										style={{ color: theme.palette.text.primary }}
									>
										{item}
									</Link>
								</motion.li>
							);
						})}
					</ul>
				</nav>

				<Stack direction="row" spacing={1} alignItems="center">
					<IconButton onClick={toggleColorMode} color="inherit">
						{mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
					</IconButton>

					<div className={style.menuSection}>
						<IconButton
							sx={{ color: theme.palette.text.primary }}
							aria-label='open drawer'
							onClick={() => {
								setSidebarOpened(true);
							}}
						>
							<MenuIcon />
						</IconButton>
					</div>
				</Stack>

				<Outlet />
			</motion.div>

			<AnimatePresence>
				{visitedCount !== undefined && visitedCount !== null && (
					<motion.div 
						initial={{ opacity: 0, scale: 0.5 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.5 }}
						className={style.visiter}
					>
						<div>Visitors</div>
						<div className={style.visiterCount}>
							<span>+</span>
							<CountUp start={0} end={visitedCount} key={visitedCount} duration={2} />
						</div>
					</motion.div>
				)}
			</AnimatePresence>

			<AnimatePresence>
				{sidebarOpened && (
					<>
						<motion.div 
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className={style.overlay}
							onClick={() => setSidebarOpened(false)}
						/>
						<motion.div
							initial={{ x: '100%' }}
							animate={{ x: 0 }}
							exit={{ x: '100%' }}
							transition={{ type: 'spring', damping: 25, stiffness: 200 }}
							className={style.sideBarContent}
							style={{ 
								backgroundColor: theme.palette.background.paper,
								color: theme.palette.text.primary
							}}
						>
							<Stack direction='row' justifyContent='flex-end' sx={{ p: 2 }}>
								<IconButton
									sx={{ color: theme.palette.text.primary }}
									onClick={() => {
										setSidebarOpened(false);
									}}
								>
									<CloseIcon />
								</IconButton>
							</Stack>

							<Stack spacing={2} sx={{ p: 3 }}>
								{navItems.map((item, index) => {
									return (
										<motion.div
											key={index}
											whileHover={{ x: 10 }}
											onClick={() => {
												setSidebarOpened(false);
											}}
										>
											<Link
												className={style.link}
												to={navItemsLinkId[index]}
												style={{ color: theme.palette.text.primary, fontSize: '1.5rem' }}
											>
												{item}
											</Link>
										</motion.div>
									);
								})}
							</Stack>
						</motion.div>
					</>
				)}
			</AnimatePresence>
		</>
	);
};

export default Navbar;
